import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { DarwinCol, DarwinRow } from 'components/darwin-ui';
import DarwinTypography from 'components/darwin-ui/Typography';
import { SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from '../../Products.module.css';
import { InputType } from 'types/genericTypes';
import { GenericInput } from '../../../GenericInput';
import {
  ProductInputProps,
  CreateProductWithoutFormData,
} from 'types/productsTypes';

const { Title } = DarwinTypography;

interface ProductMetaDataSectionProps {
  control: Control<CreateProductWithoutFormData>;
  errors: FieldErrors<CreateProductWithoutFormData>;
}

export const ProductMetaDataSection: React.FC<ProductMetaDataSectionProps> = ({
  control,
  errors,
}) => {
  const { t } = useTranslation();

  const firstColumnInputs: ProductInputProps = [
    {
      inputType: InputType.INPUT,
      fieldName: 'createdBy',
      label: t('product.view.metadata-section.created-by'),
      showRequiredAsterisk: false,
      inputRules: {},
      disabled: true,
    },
    {
      inputType: InputType.DATEPICKER,
      fieldName: 'createdAt',
      label: t('product.view.metadata-section.created-date'),
      showRequiredAsterisk: false,
      inputRules: {},
      disabled: true,
    },
  ];

  const secondColumnInputs: ProductInputProps = [
    {
      inputType: InputType.INPUT,
      fieldName: 'modifiedBy',
      label: t('product.view.metadata-section.modified-by'),
      showRequiredAsterisk: false,
      inputRules: {},
      disabled: true,
    },
    {
      inputType: InputType.DATEPICKER,
      fieldName: 'updatedAt',
      label: t('product.view.metadata-section.modified-date'),
      showRequiredAsterisk: false,
      inputRules: {},
      disabled: true,
    },
  ];

  return (
    <>
      <Title level={5} className={styles.productFormRowTitle}>
        <SettingOutlined /> {t('product.view.metadata-section.title')}
      </Title>

      <DarwinRow className={styles.productFormRow} gutter={16}>
        <DarwinCol span={12}>
          {firstColumnInputs.map(input => (
            <GenericInput
              key={input.fieldName}
              control={control}
              errors={errors}
              {...input}
            />
          ))}
        </DarwinCol>
        <DarwinCol span={12}>
          {secondColumnInputs.map(input => (
            <GenericInput
              key={input.fieldName}
              control={control}
              errors={errors}
              {...input}
            />
          ))}
        </DarwinCol>
      </DarwinRow>
    </>
  );
};
